module.exports = __webpack_public_path__ + "img/Khaki.d234896d.png";